import type { Country } from "@/types/lookup";
import { createLookupHook } from "./createLookupHook";

export type LocationTypeName =
  | "Country"
  | "State"
  | "Province"
  | "County"
  | "District"
  | "Constituency"
  | "Ward"
  | "City"
  | "Town"
  | "Village"
  | "Neighborhood"
  | "Area"
  | "Landmark";

export interface LocationType {
  id: number;
  typeName: LocationTypeName;
}

export interface LocationLookupsData {
  countries: Country[];
  locationTypes: LocationType[];
}

export interface LocationLookupsResponse {
  success: boolean;
  message: string;
  data: LocationLookupsData;
}


export const useLocationLookups = createLookupHook<LocationLookupsData>(
  "location",
  "/lookups/location",
);
